import Image from 'next/image';
import React from 'react';
import { styled } from '@linaria/react';
import { LOGIN_BACKGROUND_IMAGE } from '~/constants';
import Logos from './Logos';
import PolicyLinks from './PolicyLinks';
type Props = {
  children?: JSX.Element | (JSX.Element | boolean)[];
  policyAndLogoShow?: boolean;
  isMobile?: boolean;
};
const IDLayout = (props: Props) => {
  const {
    children,
    policyAndLogoShow = true,
    isMobile
  } = props;
  return <Wrapper>
      {children}
      {policyAndLogoShow && <>
          <PolicyLinks />
          <Logos />
        </>}

      <Image priority={!isMobile} className="background-img" src={LOGIN_BACKGROUND_IMAGE} alt="background" fill />
    </Wrapper>;
};
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1eil6in",
  propsAsIs: false
});
export default IDLayout;

require("./index.linaria.module.css");